import { ReactComponent } from "./ic_route_result_circle_yellow.svg";

interface Props {
  width?: string;
  height?: string;
  fill?: string;
}

const RouteResultCircleYellowIcon: React.FC<Props> = (props) => (
  <ReactComponent {...props} />
);

export default RouteResultCircleYellowIcon;
